export default __webpack_public_path__ + "static/media/pic7.24847239.jpg";